import styled from 'styled-components';

export const ThreeDButtonWrap = styled.div`
// margin-left: 10px;
`;
export const EditAnd3DdButtonWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap:1rem;
	align-items:center;
`;

// `$gradient` switches the strip between the panel-production colours and the
// irradiance heatmap colours; the labels stay the same.
export const StripProduction = styled.span<{ $gradient: string }>`
background: ${({ $gradient }) => $gradient};
  max-width: 100%;
  height: 28px;
  height: auto !important;
  border-radius: 50px;
  border: 2px solid #fff;
  position: relative;
  font-family: 'Sf-Bold', sans-serif;
  display: flex;
  justify-content: space-between;
  font-size: 0.62rem;
  align-items: center;
  z-index: 1;
  padding: 0.5em 0.8em;
  width: 100%;

  &:before {
    content: 'Lowest Production';
    font-size: 1em;
    color: #fff;
    white-space: nowrap;
    flex-shrink: 0;
  }

  &:after {
    content: 'Max Production';
    position: absolute;
    right: 1em;
    color: #51250d;
    white-space: nowrap;
    flex-shrink: 0;
  }
`;

export const MainDiv = styled.div`
  // top: 1rem;
  // left: 1rem;
  z-index: 3;
  // width: 100%;
  display: flex;
  gap: 5rem;
  align-items:center;
  height: auto !important;
  // position: absolute !important;
  justify-content: space-between;
  left: 0px;
  padding: 0 8px 0 0px;
  @media (max-width: 640px){
    flex-direction:column;
    align-items: flex-start;
    gap:1rem
  }
	pointer-events: none;
`;

export const ToolBarWrapper = styled.div`
display: flex;
width: 100%;
justify-content: space-between;
pointer-events: all;
gap:.75rem;

	@media (max-width: 1325px){
	gap: 0.85rem;
	}
	@media (max-width: 512px){
			flex-wrap: wrap;
		justify-content: flex-start;
	}
		button{
		}
`;

export const EditToolOptionsDiv = styled.div`
display: flex;
align-items: center;
pointer-events: all;
    background: linear-gradient(0deg, var(--defaultBgColor), var(--defaultBgColor)), var(--secondary);
    color: var(--textHeadingColor);
    font-family: Inter;
    border: 1px solid var(--borderLightColor);
    box-shadow: none;
    border-radius: 91.4939px;
    height: 38px;
		padding: 0px;
		overflow:hidden;

		& button{
			&:last-of-type{
				padding-right: 15px !important;
				&:before{
					    right: 11px !important;
				}
			}
		}
`;
export const PanelToolWrap = styled.div`
	display: flex;
	align-items:center;
	gap: 6px;
  position: relative;
		@media (min-width: 513px){
	padding-left: .75rem;
}

	// @media(max-width:979px){
	// 	padding-left: 0;
	// }

	#add-panel{
		.buttonLabel{
			display:none;
		}
	}
`;
export const FacetPanelWrap = styled.div`
	display: flex;
	align-items:center;
	gap: 6px;
	position: relative;

	&.toolbar-btn-wrap{
		#undo, #redo{
			display:none;
		}
		#delete-obstruction-mode,.btn-drawfacet{
			.buttonLabel{
				display:none;
			}
		}
	}

`;
export const CalculatebtnWrap = styled.div`
	padding-left: 0px;
	display: flex;
	gap: .75rem;
`;
export const ToolbarLabel = styled.div`
	font-family: Inter;
	font-weight: 600;
	color: var(--subHeadingColor);
	padding-right: 0px;
	line-height: normal;
	font-size: 0.875rem;
`;

export const PanelwithOreintation = styled.div`
	position: relative;
`;
export const DrawFacetWrap = styled.div`
	position: relative;
`;

export const BtnWrap = styled.div`
	position: relative;
	border-radius: 20px;
`;

export const FacetTranslateInfoText = styled.div` 
		font-size: .875rem;
    color: var(--textTitleColor);
    line-height: 17px;
    font-weight: 400;
		`;